module.exports = __webpack_public_path__ + "img/6.760788e2.png";